import React from 'react'
import Dropdown from './Dropdown'
import arrowDown from 'assets/svg/down-arrow-blue.svg'
import styles from './CityDropdown.module.css'

export default function CityDropdown(props) {
  const { cities, ...rest } = props

  return (
    <Dropdown {...rest}>
      <Dropdown.Toggle
        className={['btn', styles.arrow]}
        toggledClassName={styles.arrowUp}
      >
        <img
          src={arrowDown}
          className="h-5"
        />
      </Dropdown.Toggle>
      <Dropdown.Content
        className={[
          styles.content,
          'right-0 md:right-auto py-2 bg-white text-sm shadow rounded'
        ]}
      >
        <div className="w-40">
          {cities.map(city => (
            <a key={city.id} href={`/food-trucks/${city.url_slug}/`}>
              {city.name}
            </a>
          ))}
        </div>
      </Dropdown.Content>
    </Dropdown>
  )
}
